"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var ImmutableAPI = _interopRequireWildcard(require("crm_data/api/ImmutableAPI"));

var _immutable = require("immutable");

var _HTTPVerbs = require("crm_data/constants/HTTPVerbs");

var url = function url(appId, formId, contactId) {
  return "integrations/v1/" + appId + "/action-forms/" + formId + "/instance?contactId=" + contactId;
};

var _default = {
  fetchAll: function fetchAll() {
    return ImmutableAPI.get('integrators/v1/portal-installs/action-forms').then(function (results) {
      return (0, _immutable.Map)({
        actionForms: results
      });
    });
  },
  fetchDynamicForm: function fetchDynamicForm(appId, formId, contactId, data) {
    return ImmutableAPI.send({
      type: _HTTPVerbs.POST,
      retries: 0
    }, url(appId, formId, contactId), {
      fields: data
    });
  },
  fetchInstance: function fetchInstance(appId, formId, contactId) {
    return ImmutableAPI.get(url(appId, formId, contactId));
  },
  submitForm: function submitForm(actionFormData, data) {
    var appId = actionFormData.get('appId');
    var formId = actionFormData.get('formId');
    var contactId = actionFormData.get('contactId');
    return ImmutableAPI.send({
      type: _HTTPVerbs.POST,
      retries: 0
    }, "/integrations/v1/" + appId + "/action-forms/" + formId + "/submit?contactId=" + contactId, data);
  }
};
exports.default = _default;
module.exports = exports.default;